import Vue from "vue";
import App from "./App.vue";
import {isField} from "./utils/index.js";
var fieldTerms = require('@/assets/fields.json');

Vue.config.productionTip = false;

var forms = document.getElementsByTagName('form');

Array.prototype.forEach.call(forms, function(el, index) { 
  Array.prototype.forEach.call(el.elements, function(e, index) {

    // For Main Checkout or if input is direct child of .google-address-autocomplete
    if(e.tagName === 'INPUT'){
      if(isField(e, fieldTerms.street.include, fieldTerms.street.exclude)){
        if(!!e.id){
          new Vue({
            render: h => h(App),
              data: {
              id: e.id,
              name: e.name,
              formElements: el.elements
            }
          }).$mount(e);
        }
        
      }
    }
  });
});

